import React from 'react';
import {ReactComponent as Logo} from '../../../Assets/Logo/logoblue.svg';
import './Logo.scss';
const LogoBlue=()=>{
    return(
        <div className="logonav logoblue">
            <Logo />
           
        </div>
    )
};
export default LogoBlue ;